import { render, staticRenderFns } from "./SimSolicitudes.vue?vue&type=template&id=524a4f22&"
import script from "./SimSolicitudes.vue?vue&type=script&lang=ts&"
export * from "./SimSolicitudes.vue?vue&type=script&lang=ts&"
import style0 from "./SimSolicitudes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports